import React, { FC, useEffect, useState } from 'react'

import ITabulador from '../../../Interfaces/Catalogos/ITabulador'
import ITabuladorConceptos from '../../../Interfaces/Catalogos/ITabuladorConceptos'
import DTOConceptos from '../../../DTO/Utils/DTOConceptos'

import CTabDataService from '../../../Services/Corresponsalias/Corresponsales.Tabuladores.Services'
import CTabDetDataService from '../../../Services/Corresponsalias/Corresponsales.Tabuladores.Detalle.Sevices'
import ClientesDataService from '../../../Services/Catalogos/Clientes.Services'

import { MsgInformativo } from '../../Utils/Toast/msgInformativo'
import { ControlledInput } from '../../Utils/ControlledInput/ControlledInput'
import DataTable from 'react-data-table-component'
import { Alert, Button, Card, Col, Container, Form, Modal, Row } from 'react-bootstrap'
import { IconContext } from 'react-icons'
import 'react-data-table-component-extensions/dist/index.css'
import { BsPlusSquareFill } from 'react-icons/bs'
import IClientes from '../../../Interfaces/Catalogos/IClientes'
import { FcTimeline } from 'react-icons/fc'
import { FaEraser, FaTimesCircle } from 'react-icons/fa'

interface IProps {}

interface IselectedRows {
  allSelected: boolean
  selectedCount: number
  selectedRows: any
}

export default function CatTabuladores (props: IProps) {
  const [UserId, setUserId] = useState(() => {
    const stickyValue = window.localStorage.getItem('UserId')
    return stickyValue !== null ? JSON.parse(stickyValue) : 0
  })
  const [Tabulador, setTabulador] = useState(0)
  const [Concepto, setConcepto] = useState(0)
  const [Cliente, setCliente] = useState(0)
  const [Clientes, setClientes] = useState<Array<IClientes>>()
  const [NombreTabulador, setNombreTabulador] = useState('')
  const [DetalleConceptos, setDetalleConceptos] = useState<ITabuladorConceptos[]>([])
  const [CatConceptos, setCatConceptos] = useState<DTOConceptos[]>([])
  const [Tabuladores, setTabuladores] = useState<ITabulador[]>([])
  const [AllTabuladores, setAllTabuladores] = useState<ITabulador[]>([])
  const [Costo, setCosto] = useState('')
  const [header, setHeader] = useState('')
  const [msgColor, setMsgColor] = React.useState('primary')
  const [show, setShowMsg] = useState(false)
  const [msg, setMsg] = useState('')
  const [DialogTabs, setDialogTabs] = useState(false)

  const columnsConcepts = [
    {
      name: 'id',
      selector: (row: ITabuladorConceptos) => row.id,
      sortable: true,
    },
    {
      name: 'Concepto',
      width: '70%',
      selector: (row: ITabuladorConceptos) => row.concepto,
      sortable: true,
    },
    {
      name: 'Costo',
      cell: (row: ITabuladorConceptos) => (
        <ControlledInput
          id={row.id}
          value={row.costo}
          postCost={(id, value) => {
            postCost(id, value)
          }}
        />
      ),
    },
  ]

  const columnsTabs = [
    {
      name: 'id',
      selector: (row: ITabulador) => row.id,
      sortable: true,
    },
    {
      name: 'Nombre',
      width: '70%',
      cell: (row: ITabulador) => (
        <div
          style={{ width: '450px', cursor: 'pointer' }}
          onClick={() => {
            setTabulador(row.id)
            setNombreTabulador(row.nombre)
          }}
        >
          {row.nombre}
        </div>
      ),
      sortable: true,
    },
    {
      name: 'Elimina',
      cell: (row: ITabulador) => (
        <div
          style={{ textAlign: 'center', cursor: 'pointer' }}
          onClick={() => {
            setTabulador(row.id)
            setNombreTabulador(row.nombre)
            setDialogTabs(true)
          }}
        >
          <IconContext.Provider value={{ color: 'red', size: '25px' }}>
            <FaTimesCircle />
          </IconContext.Provider>
        </div>
      ),
    },
  ]

  const postCost = (id: number, Cost: number) => {
    const data: ITabuladorConceptos = {
      id: id,
      idTabulador: Tabulador,
      idConcepto: Concepto,
      concepto: '',
      costo: Cost,
      activo: 1,
    }
    CTabDetDataService.Append(data)
      .then((response) => {
        setDetalleConceptos(response.data)
        setHeader('Confirmacion')
        setMsg('La informacion se guardo corrctamente')
        setShowMsg(true)
      })
      .catch((e: Error) => {
        setHeader('Error')
        setMsg('Ocurrio un error: ' + e)
        setShowMsg(true)
        return
      })
  }

  const deleteTabulador = () => {
    CTabDataService.Delete(Tabulador)
      .then((response) => {
        if (response.status === 200) {
          setHeader('Informativo')
          setMsg(response.data.respuesta)
          setShowMsg(true)
          setDialogTabs(false)
          setTabuladores(Tabuladores.filter((data) => data.id != Tabulador))
          setAllTabuladores(Tabuladores)
          return
        }
      })
      .catch((e: Error) => {
        setHeader('Error')
        setMsg('Ocurrio un error: ' + e)
        setShowMsg(true)
        return
      })
  }

  useEffect(() => {
    CTabDetDataService.getAllConcepts()
      .then((response) => {
        setCatConceptos(response.data)
      })
      .catch((e: Error) => {
        setHeader('Error')
        setMsg('Ocurrio un error: ' + e)
        setShowMsg(true)
        return
      })
    ClientesDataService.getAllClientes(UserId)
      .then((response) => {
        setClientes(response.data)
      })
      .catch((e: Error) => {
        setHeader('Error')
        setMsg('Ocurrio un error: ' + e)
        setShowMsg(true)
        return
      })
  }, [])

  useEffect(() => {
    CTabDetDataService.GetDetailByIdTab(Tabulador)
      .then((response) => {
        setDetalleConceptos(response.data)
      })
      .catch((e: Error) => {
        setHeader('Error')
        setMsg('Ocurrio un error: ' + e)
        setShowMsg(true)
        return
      })
    console.log(Tabulador)
  }, [Tabulador])

  useEffect(() => {
    if (Cliente > 0) {
      setNombreTabulador('')
      setTabuladores([])
      setDetalleConceptos([])
      CTabDataService.GetByCustomer(Cliente)
        .then((response) => {
          setTabuladores(response.data)
        })
        .catch((e: Error) => {
          setHeader('Error')
          setMsg('Ocurrio un error: ' + e)
          setShowMsg(true)
          return
        })
    }
  }, [Cliente])

  const filtraTabulador = (e: any) => {
    if (e.target.value !== '') {
      setTabuladores(
        AllTabuladores.filter(function (el) {
          return el.nombre.toLocaleLowerCase().includes(e.target.value.toLocaleLowerCase())
        })
      )
    } else {
      setTabuladores(AllTabuladores)
    }
  }

  const saveForm = () => {
    const data: ITabulador = {
      id: Tabulador,
      idCliente: Cliente,
      nombre: NombreTabulador,
    }
    CTabDataService.Append(data)
      .then((response) => {
        if (response.status === 200) {
          setHeader('Informativo')
          setMsg('La informacion se guardo correctamente')
          setShowMsg(true)
          if (Tabulador > 0) {
            let tmp = Tabuladores
            let idx = tmp.findIndex((obj) => obj.id == Tabulador)
            tmp[idx].nombre = NombreTabulador
            setTabuladores(tmp)
            setAllTabuladores(tmp)
          } else {
            setTabulador(response.data.id)
            const tmp = [...Tabuladores, response.data]
            setTabuladores(tmp)
            setAllTabuladores(tmp)
          }
          return
        }
      })
      .catch((e: Error) => {
        setHeader('Error')
        setMsg('Ocurrio un error: ' + e)
        setShowMsg(true)
        return
      })
  }

  const addConcept = () => {
    if (Tabulador === 0) {
      setHeader('Error')
      setMsg('Por favor, primero seleccione el tabulador')
      setShowMsg(true)
      return
    }
    if (Concepto === 0) {
      setHeader('Error')
      setMsg('Por favor, primero seleccione el concepto')
      setShowMsg(true)
      return
    }
    postCost(0, 0)
  }

  return (
    <div>
      <Card>
        <Card.Body>
          <Card style={{ height: '100%' }}>
            <Card.Header as='h4'>Tabuladores</Card.Header>
            <Card.Body>
              <Container fluid>
                <Alert variant='primary'>
                  <Row>
                    <Col xs={1} style={{ paddingTop: '5px' }}>
                      <h5>Cliente: </h5>
                    </Col>
                    <Col xs={5}>
                      <h4>
                        <Form.Control
                          as='select'
                          onChange={(e) => {
                            setCliente(parseInt(e.target.value))
                          }}
                          className='form-select form-select-sm'
                          style={{ fontSize: '18px' }}
                        >
                          <option value='0'>-SELECCIONE-</option>
                          {Clientes
                            ? Clientes.map((c) => {
                                return (
                                  <option value={c.sClave} key={c.sClave}>
                                    {c.sRazonSocial}
                                  </option>
                                )
                              })
                            : null}
                        </Form.Control>
                      </h4>
                    </Col>
                    <Col
                      xs={1}
                      style={{ textAlign: 'right', paddingTop: '5px', cursor: 'pointer' }}
                      onClick={() => {
                        setTabulador(0)
                        setNombreTabulador('')
                      }}
                    >
                      <IconContext.Provider value={{ color: 'orange', size: '25px' }}>
                        <FaEraser />
                      </IconContext.Provider>
                    </Col>
                    <Col xs={1} style={{ paddingTop: '5px' }}>
                      <div>
                        <h5>Tabulador</h5>
                      </div>
                    </Col>
                    <Col xs={3}>
                      <h4>
                        <Form.Control
                          type='text'
                          id='NombreTabulador'
                          size='sm'
                          value={NombreTabulador}
                          onChange={(e) => {
                            setNombreTabulador(e.target.value)
                          }}
                          placeholder='Nombre del tabulador'
                          style={{ fontSize: '18px' }}
                        />
                      </h4>
                    </Col>
                    <Col>
                      <Button
                        variant='primary'
                        size='sm'
                        style={{ paddingLeft: '10px', paddingRight: '10px' }}
                        onClick={() => saveForm()}
                      >
                        Guardar
                      </Button>
                    </Col>
                  </Row>
                </Alert>
                <Row>
                  <Col xs={6}>
                    <Card style={{}}>
                      <Card.Body>
                        <Card.Subtitle className='mb-2 text-muted'>
                          <Row>
                            <Col xs={2} style={{ paddingTop: '8px' }}>
                              Tabulador
                            </Col>
                            <Col xs={10}>
                              <Form.Control
                                type='text'
                                size='sm'
                                placeholder='Busqueda de tabulador...'
                                onChange={(e) => {
                                  filtraTabulador(e)
                                }}
                              />
                            </Col>
                          </Row>
                        </Card.Subtitle>
                        <DataTable
                          noHeader
                          defaultSortFieldId={'id'}
                          defaultSortAsc={true}
                          pagination
                          highlightOnHover
                          columns={columnsTabs}
                          data={Tabuladores}
                        />
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col xs={6}>
                    <Card style={{}}>
                      <Card.Body>
                        <Card.Subtitle className='mb-2 text-muted'>
                          <Row>
                            <Col xs={2} style={{ paddingTop: '8px' }}>
                              Conceptos
                            </Col>
                            <Col xs={9}>
                              <Form.Control
                                as='select'
                                onChange={(e) => setConcepto(parseInt(e.target.value))}
                                className='form-select form-select-sm'
                                style={{ fontSize: '17px' }}
                              >
                                <option value='0'>- Seleccione -</option>
                                {CatConceptos
                                  ? CatConceptos.map((c) => {
                                      return (
                                        <option value={c.id} key={c.id}>
                                          {c.concepto}
                                        </option>
                                      )
                                    })
                                  : null}
                              </Form.Control>
                            </Col>
                            <Col style={{ paddingTop: '5px' }}>
                              <Form.Label
                                onClick={() => {
                                  addConcept()
                                }}
                                style={{ cursor: 'pointer' }}
                              >
                                <IconContext.Provider value={{ color: 'green', size: '30px' }}>
                                  <BsPlusSquareFill />
                                </IconContext.Provider>
                              </Form.Label>
                            </Col>
                          </Row>
                        </Card.Subtitle>
                        <DataTable
                          noHeader
                          defaultSortFieldId={'id'}
                          defaultSortAsc={true}
                          pagination
                          highlightOnHover
                          columns={columnsConcepts}
                          data={DetalleConceptos}
                        />
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Container>
            </Card.Body>
          </Card>
        </Card.Body>
      </Card>
      <Modal
        show={DialogTabs}
        onHide={() => {
          setDialogTabs(false)
        }}
        size='sm'
      >
        <Modal.Body>
          ¿Esta seguro de eliminar:
          <br /> {NombreTabulador}?
        </Modal.Body>
        <Modal.Footer>
          <Row>
            <Col xs={6} style={{ textAlign: 'left', paddingRight: '100px' }}>
              <Button
                variant='danger'
                onClick={deleteTabulador}
                size='sm'
                style={{ paddingRight: '20px', paddingLeft: '20px' }}
              >
                Si
              </Button>
            </Col>
            <Col xs={6} style={{ textAlign: 'right' }}>
              <Button
                variant='secondary'
                onClick={() => {
                  setDialogTabs(false)
                }}
                size='sm'
              >
                Cerrar
              </Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
      <MsgInformativo
        show={show}
        msg={msg}
        header={header}
        msgColor={msgColor}
        closeToast={() => {
          setShowMsg(false)
        }}
      />
    </div>
  )
}
